import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { SortAscIcon, SortDescIcon } from '@beef/ui-kit';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function SortButton({
  isActive,
  onClick,
  className,
  buttonText,
  isReverse,
  reverseMode,
  reverseText,
  slug,
  isMobile,
}) {
  const activeAndReversed = isActive && isReverse;
  return (
    <button
      className={cx('sortButton', className, isMobile && 'mobile', isActive && 'active')}
      onClick={() => {
        onClick(slug, reverseMode, isReverse);
      }}
      name="Отсортировать"
      type="button"
    >
      {reverseMode ?
        <>
          {activeAndReversed ?
            <SortAscIcon size="s" fill="#767676" className={cx('buttonIcon')} />
          : <SortDescIcon size="s" fill="#767676" className={cx('buttonIcon')} />}
          <span className={cx('buttonText')}>{activeAndReversed ? reverseText : buttonText}</span>
        </>
      : null}
      {!reverseMode ?
        <span className={cx('buttonText')}>{buttonText}</span>
      : null}
    </button>
  );
}

SortButton.defaultProps = {
  onClick: () => {},
};

SortButton.propTypes = {
  isActive: PropTypes.bool,
  isReverse: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  reverseMode: PropTypes.bool,
  reverseText: PropTypes.string,
  buttonText: PropTypes.string,
  slug: PropTypes.string,
  isMobile: PropTypes.bool,
};
